import { BasePathProvider, useBasePath } from "components/Providers";
import PersonHeader from "./PersonHeader";
import ApplicationDetailTabs from "./Tabs";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { get } from 'store/application/student-applications'
import { useParams } from "react-router-dom";

export default function ApplicationDetailIndex({ clientSchools, academicYears }) {
  const basePath = useBasePath()
  const [applicationRecord, setApplicationRecord] = useState()
  const dispatch = useDispatch()
  const { applicationId } = useParams()

  useEffect(() => {
    if (applicationId) {
      dispatch(get({ id: applicationId })).then(res => {
        setApplicationRecord(res.payload)
      })
    } else {
      setApplicationRecord(null)
    }
  }, [dispatch, applicationId])

  return (
    <BasePathProvider value={`${basePath}/application-list`}>
      <PersonHeader applicationRecord={applicationRecord} clientSchools={clientSchools} />
      <ApplicationDetailTabs applicationRecord={applicationRecord} setApplicationRecord={setApplicationRecord} clientSchools={clientSchools} academicYears={academicYears} />

    </BasePathProvider>
  )
}
